import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:mb-6 crm:items-start" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "crm:flex crm:items-center" }
const _hoisted_6 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_7 = { class: "control-label col-sm-6" }
const _hoisted_8 = { class: "col-sm" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_11 = { class: "control-label col-sm-6" }
const _hoisted_12 = { class: "col-sm" }
const _hoisted_13 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_14 = { class: "control-label col-sm-6" }
const _hoisted_15 = { class: "col-sm" }
const _hoisted_16 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_17 = { class: "control-label col-sm-6" }
const _hoisted_18 = { class: "col-sm" }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_21 = { class: "control-label col-sm-6" }
const _hoisted_22 = { class: "col-sm" }
const _hoisted_23 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_24 = { class: "control-label col-sm-6" }
const _hoisted_25 = { class: "col-sm" }
const _hoisted_26 = { class: "crm:flex crm:items-center" }
const _hoisted_27 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_28 = { class: "control-label col-sm-6" }
const _hoisted_29 = { class: "col-sm" }
const _hoisted_30 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_31 = { class: "control-label col-sm-6" }
const _hoisted_32 = { class: "col-sm" }
const _hoisted_33 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_34 = { class: "control-label col-sm-6" }
const _hoisted_35 = { class: "col-sm" }
const _hoisted_36 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_37 = { class: "control-label col-sm-6" }
const _hoisted_38 = { class: "col-sm" }
const _hoisted_39 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_40 = { class: "control-label col-sm-6" }
const _hoisted_41 = { class: "col-sm" }
const _hoisted_42 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_43 = { class: "control-label col-sm-6" }
const _hoisted_44 = { class: "col-sm" }
const _hoisted_45 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_46 = { class: "control-label col-sm-6" }
const _hoisted_47 = { class: "col-sm" }
const _hoisted_48 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_49 = { class: "control-label col-sm-6" }
const _hoisted_50 = { class: "col-sm" }
const _hoisted_51 = { key: 3 }
const _hoisted_52 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_53 = { class: "control-label col-sm-6" }
const _hoisted_54 = { class: "col-sm" }
const _hoisted_55 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_56 = { class: "control-label col-sm-6" }
const _hoisted_57 = { class: "col-sm" }
const _hoisted_58 = { key: 4 }
const _hoisted_59 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_60 = { class: "control-label col-sm-6" }
const _hoisted_61 = { class: "col-sm" }
const _hoisted_62 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_63 = { class: "control-label col-sm-6" }
const _hoisted_64 = { class: "col-sm" }
const _hoisted_65 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_66 = { class: "control-label col-sm-6" }
const _hoisted_67 = { class: "col-sm" }
const _hoisted_68 = { key: 5 }
const _hoisted_69 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_70 = { class: "control-label col-sm-6" }
const _hoisted_71 = { class: "col-sm" }
const _hoisted_72 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_73 = { class: "control-label col-sm-6" }
const _hoisted_74 = { class: "col-sm" }
const _hoisted_75 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_76 = { class: "control-label col-sm-6" }
const _hoisted_77 = { class: "col-sm" }
const _hoisted_78 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_79 = { class: "control-label col-sm-6" }
const _hoisted_80 = { class: "col-sm" }
const _hoisted_81 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_82 = { class: "control-label col-sm-6" }
const _hoisted_83 = { class: "col-sm" }
const _hoisted_84 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_85 = { class: "control-label col-sm-6" }
const _hoisted_86 = { class: "col-sm" }
const _hoisted_87 = { class: "crm:flex crm:items-center" }
const _hoisted_88 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_89 = { class: "control-label col-sm-6" }
const _hoisted_90 = { class: "col-sm" }
const _hoisted_91 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_92 = { class: "control-label col-sm-6" }
const _hoisted_93 = { class: "col-sm" }
const _hoisted_94 = {
  key: 3,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_95 = { class: "control-label col-sm-6" }
const _hoisted_96 = { class: "col-sm" }
const _hoisted_97 = {
  key: 4,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_98 = { class: "control-label col-sm-6" }
const _hoisted_99 = { class: "col-sm" }
const _hoisted_100 = {
  key: 5,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_101 = { class: "control-label col-sm-6" }
const _hoisted_102 = { class: "col-sm" }

import { watch , ref, inject } from 'vue'
import { usePreventivo } from '../../composable/usePreventivo';
import FormSocietarioHelper from "../../pages/preventivi/json/societario/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import BaseInputTextArray from "fallco-frontend-framework/src/vue/components/form/BaseInputTextArray.vue";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";
import {add} from '../../svg/svgs.js'

export default {
  __name: 'FormSocietarioScissioniFusioni',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo();
const props = __props;
const emits = __emit;
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale');
switch (props.formName) {
  case 'deliberaDiScissioneSocietaScindenda':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['deliberaDiScissioneSocietaScindenda'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['deliberaDiScissioneSocietaScindenda'];
    break
  case 'deliberaDiScissioneSocietaScissionaria':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['deliberaDiScissioneSocietaScissionaria'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['deliberaDiScissioneSocietaScissionaria'];
    break
  case 'attoDiScissione':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['attoDiScissione'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['attoDiScissione'];
    break
  case 'deliberaDiFusioneSocietaIncorporanda':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['deliberaDiFusioneSocietaIncorporanda'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['deliberaDiFusioneSocietaIncorporanda'];
    break
  case 'deliberaDiFusioneSocietaIncorporante':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['deliberaDiFusioneSocietaIncorporante'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['deliberaDiFusioneSocietaIncorporante'];
    break
  case 'attoDiFusione':
    validazione = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['attoDiFusione'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaSocietario['sottocategoriaScissioniFusioni']['attoDiFusione'];
    break
}
const testoInfoCompilazione = ref([]);
testoInfoCompilazione.value =  FormSocietarioHelper.sottocategoriaScissioniFusioni[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
watch(validazione, () => {
  emits('changeDatiPreventivo')
}, { deep: true });
let indexHelperClosing = {
  calcolo: FormSocietarioHelper.sottocategoriaScissioniFusioni[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}
if(validazione){
  validazione.tipo_preventivo.value = 'societario/scissioni_fusioni/' + props.tipoPreventivo.data.url
}
function select_ufficio_del_territorio(event){
  if(event.target.value === 'pubblicita_immobiliare_completa'){
    validazione.quante_conservatorie.required = true;
    validazione.quante_conservatorie.value = '1';
    validazione.quante_volture.required = false;
    validazione.quante_volture.value = '';
  } else if(event.target.value === 'solo_voltura_catastale'){
    validazione.quante_volture.required = true;
    validazione.quante_volture.value = '1';
    validazione.quante_conservatorie.required = false;
    validazione.quante_conservatorie.value = '';
  } else {
    validazione.quante_volture.required = false;
    validazione.quante_volture.value = '';
    validazione.quante_conservatorie.required = false;
    validazione.quante_conservatorie.value = '';
  }
}
function select_fusione_comporta_creazione_nuova_societa(event){
  if(event.target.value === 'si'){
    validazione.tassa_concessione_governativa.required = true;
    validazione.diritto_annuale_registro_imprese.required = true;
    validazione.capitale_sociale_nuova_societa.required = true;
  } else {
    validazione.tassa_concessione_governativa.required = false;
    validazione.tassa_concessione_governativa.value = '';
    validazione.diritto_annuale_registro_imprese.required = false;
    validazione.diritto_annuale_registro_imprese.value = '';
    validazione.capitale_sociale_nuova_societa.required = false;
    validazione.capitale_sociale_nuova_societa.value = '';
  }
}
function delibera_aumento_capitale(event){
  if(event.target.value === 'si'){
    validazione.valore_deliberato_aumento_capitale.required = true;
  }else{
    validazione.valore_deliberato_aumento_capitale.required = false;
    validazione.valore_deliberato_aumento_capitale.value = '';
  }
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'deliberaDiScissioneSocietaScindenda')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).valore_patrimonio_netto_trasferito.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_patrimonio_netto_trasferito.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BaseInputTextArray, {
                name: "valore_patrimonio_netto_trasferito",
                params: {
            type:_unref(validazione).valore_patrimonio_netto_trasferito.type,
            isvalid: 'true'
          },
                "validate-to": _unref(validazione).valore_patrimonio_netto_trasferito.value,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).valore_patrimonio_netto_trasferito.value) = $event))
              }, {
                "add-cta": _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    _cache[36] || (_cache[36] = _createElementVNode("span", null, "Aggiungi valore", -1 /* CACHED */)),
                    _createVNode(_component_base_icon, {
                      icon: _unref(add),
                      class: "crm:ml-3",
                      sizing: {width: '15px', height:'15px'}
                    }, null, 8 /* PROPS */, ["icon"])
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["params", "validate-to"])
            ])
          ]),
          (_unref(regimeFiscale) === 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "valore_patrimonio_netto_trasferito",
            validazione: validazioneEquoCompenso.value,
            "dynamic-input": true,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'deliberaDiScissioneSocietaScissionaria')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_11, [
                _createTextVNode(_toDisplayString(_unref(validazione).si_delibera_aumento_del_capitale.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.si_delibera_aumento_del_capitale.ref]
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_base_select, {
                  name: "si_delibera_aumento_del_capitale",
                  options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                  state: __props.readonly === true ?'disable':'',
                  onChange: _cache[2] || (_cache[2] = $event => (delibera_aumento_capitale($event))),
                  validateTo: _unref(validazione).si_delibera_aumento_del_capitale,
                  "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).si_delibera_aumento_del_capitale) = $event))
                }, null, 8 /* PROPS */, ["state", "validateTo"])
              ])
            ]),
            (_unref(validazione).si_delibera_aumento_del_capitale.value === 'si')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_unref(validazione).valore_deliberato_aumento_capitale.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_deliberato_aumento_capitale.ref]
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_base_input_text, {
                      id: "valore_deliberato_aumento_capitale",
                      name: "valore_deliberato_aumento_capitale",
                      class: "placeholder-right",
                      placeholder: "0,00",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).valore_deliberato_aumento_capitale,
                      "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).valore_deliberato_aumento_capitale) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_unref(regimeFiscale) === 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_17, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            (_unref(validazione).si_delibera_aumento_del_capitale.value === 'si')
              ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                  key: 2,
                  "input-riferimento-calcolo": "valore_deliberato_aumento_capitale",
                  validazione: validazioneEquoCompenso.value,
                  "dynamic-input": false,
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
              : _createCommentVNode("v-if", true)
          ]))
        : (__props.formName === 'attoDiScissione')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_unref(validazione).quante_societa_vengono_scisse.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.quante_societa_vengono_scisse.ref]
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_base_input_text, {
                    id: "quante_societa_vengono_scisse",
                    name: "quante_societa_vengono_scisse",
                    class: "placeholder-left",
                    placeholder: "Indicare il numero di società",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).quante_societa_vengono_scisse,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).quante_societa_vengono_scisse) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_24, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_del_patrimonio_netto_assegnato_a_ciascuna_societa_beneficiaria.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_del_patrimonio_netto_assegnato_a_ciascuna_societa_beneficiaria.ref]
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(BaseInputTextArray, {
                    name: "valore_del_patrimonio_netto_assegnato_a_ciascuna_societa_beneficiaria",
                    params: {
            type:_unref(validazione).valore_del_patrimonio_netto_assegnato_a_ciascuna_societa_beneficiaria.type,
            isvalid: 'true'
          },
                    "validate-to": _unref(validazione).valore_del_patrimonio_netto_assegnato_a_ciascuna_societa_beneficiaria.value,
                    "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).valore_del_patrimonio_netto_assegnato_a_ciascuna_societa_beneficiaria.value) = $event))
                  }, {
                    "add-cta": _withCtx(() => [
                      _createElementVNode("span", _hoisted_26, [
                        _cache[37] || (_cache[37] = _createElementVNode("span", null, "Aggiungi valore", -1 /* CACHED */)),
                        _createVNode(_component_base_icon, {
                          icon: _unref(add),
                          class: "crm:ml-3",
                          sizing: {width: '15px', height:'15px'}
                        }, null, 8 /* PROPS */, ["icon"])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["params", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_28, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_capitale.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_capitale.ref]
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_base_input_text, {
                    id: "valore_capitale",
                    name: "valore_capitale",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore_capitale,
                    "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).valore_capitale) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_31, [
                  _createTextVNode(_toDisplayString(_unref(validazione).diritto_annuale_registro_imprese.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.diritto_annuale_registro_imprese.ref]
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_base_select, {
                    name: "diritto_annuale_registro_imprese",
                    options: [{name: 'Versato dal notaio', value: 'versato_dal_notaio'},
                       {name: 'Versato dall\'azienda', value: 'versato_dall_azienda'}],
                    isSelected: _unref(validazione).diritto_annuale_registro_imprese.value !== '',
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).diritto_annuale_registro_imprese,
                    "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).diritto_annuale_registro_imprese) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_34, [
                  _createTextVNode(_toDisplayString(_unref(validazione).tassa_concessione_governativa.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tassa_concessione_governativa.ref]
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_base_select, {
                    name: "tassa_concessione_governativa",
                    options: [{name: 'Versato dal notaio', value: 'versato_dal_notaio'},
                       {name: 'Versato dall\'azienda', value: 'versato_dall_azienda'}],
                    isSelected: _unref(validazione).tassa_concessione_governativa.value !== '',
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).tassa_concessione_governativa,
                    "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).tassa_concessione_governativa) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_37, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ufficio_del_territorio.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ufficio_del_territorio.ref]
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_base_select, {
                    name: "ufficio_del_territorio",
                    options: [{name: 'Pubblicità immobiliare completa', value: 'pubblicita_immobiliare_completa'},
          {name: 'Solo voltura catastale', value: 'solo_voltura_catastale'}],
                    isSelected: _unref(validazione).ufficio_del_territorio.value !== '',
                    onChange: _cache[11] || (_cache[11] = $event => (select_ufficio_del_territorio($event))),
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).ufficio_del_territorio,
                    "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).ufficio_del_territorio) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_40, [
                  _createTextVNode(_toDisplayString(_unref(validazione).tipo_societa.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_societa.ref]
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_base_select, {
                    name: "tipo_societa",
                    options: [{name: 'Società di capitali', value: 'societa_di_capitale'},{name: 'Società di persone', value: 'societa_di_persone'}],
                    state: __props.readonly === true ?'disable':'',
                    isSelected: _unref(validazione).tipo_societa.value !== '',
                    validateTo: _unref(validazione).tipo_societa,
                    "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).tipo_societa) = $event))
                  }, null, 8 /* PROPS */, ["state", "isSelected", "validateTo"])
                ])
              ]),
              (_unref(validazione).ufficio_del_territorio.value === 'pubblicita_immobiliare_completa')
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_43, [
                      _createTextVNode(_toDisplayString(_unref(validazione).quante_conservatorie.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.quante_conservatorie.ref]
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_base_input_text, {
                        id: "quante_conservatorie",
                        name: "quante_conservatorie",
                        class: "placeholder-right crm:text-right",
                        placeholder: "Indicare il numero di conservatorie",
                        disabled: __props.readonly,
                        "validate-to": _unref(validazione).quante_conservatorie,
                        "onUpdate:validateTo": _cache[14] || (_cache[14] = $event => ((_unref(validazione).quante_conservatorie) = $event))
                      }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_unref(validazione).ufficio_del_territorio.value === 'solo_voltura_catastale')
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_46, [
                      _createTextVNode(_toDisplayString(_unref(validazione).quante_volture.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.quante_volture.ref]
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_base_input_text, {
                        id: "quante_volture",
                        name: "quante_volture",
                        class: "placeholder-right crm:text-right",
                        placeholder: "Indicare il numero di volture",
                        disabled: __props.readonly,
                        "validate-to": _unref(validazione).quante_volture,
                        "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).quante_volture) = $event))
                      }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_unref(regimeFiscale) === 'ordinario')
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_49, [
                      _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_base_input_checkbox, {
                        class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                        name: "ritenuta_acconto",
                        label: "Si, applicabile",
                        "validate-to": _unref(validazione).ritenuta_acconto,
                        "onUpdate:validateTo": _cache[16] || (_cache[16] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                      }, null, 8 /* PROPS */, ["class", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(RegimeFiscale, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(AliquoteContributiRepertoriali, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(CalcoloEquoCompenso, {
                "input-riferimento-calcolo": "valore_del_patrimonio_netto_assegnato_a_ciascuna_societa_beneficiaria",
                validazione: validazioneEquoCompenso.value,
                "dynamic-input": true,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
            ]))
          : (__props.formName === 'deliberaDiFusioneSocietaIncorporanda')
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_53, [
                    _createTextVNode(_toDisplayString(_unref(validazione).valore_patrimonio_societa_incorporanda.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_patrimonio_societa_incorporanda.ref]
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_base_input_text, {
                      id: "valore_patrimonio_societa_incorporanda",
                      name: "valore_patrimonio_societa_incorporanda",
                      class: "placeholder-right",
                      placeholder: "0,00",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).valore_patrimonio_societa_incorporanda,
                      "onUpdate:validateTo": _cache[17] || (_cache[17] = $event => ((_unref(validazione).valore_patrimonio_societa_incorporanda) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]),
                (_unref(regimeFiscale) === 'ordinario')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_56, [
                        _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_base_input_checkbox, {
                          class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                          name: "ritenuta_acconto",
                          label: "Si, applicabile",
                          "validate-to": _unref(validazione).ritenuta_acconto,
                          "onUpdate:validateTo": _cache[18] || (_cache[18] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                        }, null, 8 /* PROPS */, ["class", "validate-to"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode(RegimeFiscale, {
                  validazione: _unref(validazione),
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                _createVNode(AliquoteContributiRepertoriali, {
                  validazione: _unref(validazione),
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                _createVNode(CalcoloEquoCompenso, {
                  "input-riferimento-calcolo": "valore_patrimonio_societa_incorporanda",
                  validazione: validazioneEquoCompenso.value,
                  "dynamic-input": false,
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
              ]))
            : (__props.formName === 'deliberaDiFusioneSocietaIncorporante')
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_60, [
                      _createTextVNode(_toDisplayString(_unref(validazione).si_delibera_aumento_del_capitale.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.si_delibera_aumento_del_capitale .ref]
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createVNode(_component_base_select, {
                        name: "si_delibera_aumento_del_capitale",
                        options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                        state: __props.readonly === true ?'disable':'',
                        onChange: _cache[19] || (_cache[19] = $event => (delibera_aumento_capitale($event))),
                        validateTo: _unref(validazione).si_delibera_aumento_del_capitale,
                        "onUpdate:validateTo": _cache[20] || (_cache[20] = $event => ((_unref(validazione).si_delibera_aumento_del_capitale) = $event))
                      }, null, 8 /* PROPS */, ["state", "validateTo"])
                    ])
                  ]),
                  (_unref(validazione).si_delibera_aumento_del_capitale.value === 'si')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_63, [
                          _createTextVNode(_toDisplayString(_unref(validazione).valore_deliberato_aumento_capitale.label), 1 /* TEXT */)
                        ])), [
                          [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_deliberato_aumento_capitale.ref]
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_component_base_input_text, {
                            id: "valore_deliberato_aumento_capitale",
                            name: "valore_deliberato_aumento_capitale",
                            class: "placeholder-right",
                            placeholder: "0,00",
                            disabled: __props.readonly,
                            "validate-to": _unref(validazione).valore_deliberato_aumento_capitale,
                            "onUpdate:validateTo": _cache[21] || (_cache[21] = $event => ((_unref(validazione).valore_deliberato_aumento_capitale) = $event))
                          }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_unref(regimeFiscale) == 'ordinario')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_66, [
                          _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                        ])), [
                          [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createVNode(_component_base_input_checkbox, {
                            class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                            name: "ritenuta_acconto",
                            label: "Si, applicabile",
                            "validate-to": _unref(validazione).ritenuta_acconto,
                            "onUpdate:validateTo": _cache[22] || (_cache[22] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                          }, null, 8 /* PROPS */, ["class", "validate-to"])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createVNode(RegimeFiscale, {
                    validazione: _unref(validazione),
                    helper: _unref(indexHelperClosing),
                    readonly: __props.readonly
                  }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                  _createVNode(AliquoteContributiRepertoriali, {
                    validazione: _unref(validazione),
                    helper: _unref(indexHelperClosing),
                    readonly: __props.readonly
                  }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                  (_unref(validazione).si_delibera_aumento_del_capitale.value === 'si')
                    ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                        key: 2,
                        "input-riferimento-calcolo": "valore_deliberato_aumento_capitale",
                        validazione: validazioneEquoCompenso.value,
                        "dynamic-input": false,
                        helper: _unref(indexHelperClosing),
                        readonly: __props.readonly
                      }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
                    : _createCommentVNode("v-if", true)
                ]))
              : (__props.formName === 'attoDiFusione')
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_70, [
                        _createTextVNode(_toDisplayString(_unref(validazione).quante_societa_vengono_fuse.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.quante_societa_vengono_fuse.ref]
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_base_input_text, {
                          id: "quante_societa_vengono_fuse",
                          name: "quante_societa_vengono_fuse",
                          class: "placeholder-right crm:text-right",
                          placeholder: "Indicare il numero di società",
                          disabled: __props.readonly,
                          "validate-to": _unref(validazione).quante_societa_vengono_fuse,
                          "onUpdate:validateTo": _cache[23] || (_cache[23] = $event => ((_unref(validazione).quante_societa_vengono_fuse) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_73, [
                        _createTextVNode(_toDisplayString(_unref(validazione).fusione_comporta_creazione_nuova_societa.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.fusione_comporta_creazione_nuova_societa.ref]
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_base_select, {
                          name: "fusione_comporta_creazione_nuova_societa",
                          options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                          onChange: _cache[24] || (_cache[24] = $event => (select_fusione_comporta_creazione_nuova_societa($event))),
                          state: __props.readonly === true ?'disable':'',
                          validateTo: _unref(validazione).fusione_comporta_creazione_nuova_societa,
                          "onUpdate:validateTo": _cache[25] || (_cache[25] = $event => ((_unref(validazione).fusione_comporta_creazione_nuova_societa) = $event))
                        }, null, 8 /* PROPS */, ["state", "validateTo"])
                      ])
                    ]),
                    (_unref(validazione).fusione_comporta_creazione_nuova_societa.value === 'si')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_76, [
                            _createTextVNode(_toDisplayString(_unref(validazione).capitale_sociale_nuova_societa.label), 1 /* TEXT */)
                          ])), [
                            [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.capitale_sociale_nuova_societa.ref]
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_base_input_text, {
                              id: "capitale_sociale_nuova_societa",
                              name: "capitale_sociale_nuova_societa",
                              class: "placeholder-right crm:text-right",
                              placeholder: "0,00",
                              disabled: __props.readonly,
                              "validate-to": _unref(validazione).capitale_sociale_nuova_societa,
                              "onUpdate:validateTo": _cache[26] || (_cache[26] = $event => ((_unref(validazione).capitale_sociale_nuova_societa) = $event))
                            }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_unref(validazione).fusione_comporta_creazione_nuova_societa.value === 'si')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_79, [
                            _createTextVNode(_toDisplayString(_unref(validazione).diritto_annuale_registro_imprese.label), 1 /* TEXT */)
                          ])), [
                            [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.diritto_annuale_registro_imprese.ref]
                          ]),
                          _createElementVNode("div", _hoisted_80, [
                            _createVNode(_component_base_select, {
                              name: "diritto_annuale_registro_imprese",
                              options: [{name: 'Versato dal notaio', value: 'versato_dal_notaio'},
                       {name: 'Versato dall\'azienda', value: 'versato_dall_azienda'}],
                              isSelected: _unref(validazione).diritto_annuale_registro_imprese.value != '',
                              state: __props.readonly == true ?'disable':'',
                              validateTo: _unref(validazione).diritto_annuale_registro_imprese,
                              "onUpdate:validateTo": _cache[27] || (_cache[27] = $event => ((_unref(validazione).diritto_annuale_registro_imprese) = $event))
                            }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_unref(validazione).fusione_comporta_creazione_nuova_societa.value === 'si')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_82, [
                            _createTextVNode(_toDisplayString(_unref(validazione).tassa_concessione_governativa.label), 1 /* TEXT */)
                          ])), [
                            [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tassa_concessione_governativa.ref]
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createVNode(_component_base_select, {
                              name: "tassa_concessione_governativa",
                              options: [{name: 'Versato dal notaio', value: 'versato_dal_notaio'},
                       {name: 'Versato dall\'azienda', value: 'versato_dall_azienda'}],
                              isSelected: _unref(validazione).tassa_concessione_governativa.value !== '',
                              state: __props.readonly === true ?'disable':'',
                              validateTo: _unref(validazione).tassa_concessione_governativa,
                              "onUpdate:validateTo": _cache[28] || (_cache[28] = $event => ((_unref(validazione).tassa_concessione_governativa) = $event))
                            }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_84, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_85, [
                        _createTextVNode(_toDisplayString(_unref(validazione).valore_patrimonio_netto_societa_incorporate.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_patrimonio_netto_societa_incorporate.ref]
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _createVNode(BaseInputTextArray, {
                          name: "valore_patrimonio_netto_societa_incorporate",
                          params: {
            type:_unref(validazione).valore_patrimonio_netto_societa_incorporate.type,
            isvalid: 'true'
          },
                          "validate-to": _unref(validazione).valore_patrimonio_netto_societa_incorporate.value,
                          "onUpdate:validateTo": _cache[29] || (_cache[29] = $event => ((_unref(validazione).valore_patrimonio_netto_societa_incorporate.value) = $event))
                        }, {
                          "add-cta": _withCtx(() => [
                            _createElementVNode("span", _hoisted_87, [
                              _cache[38] || (_cache[38] = _createElementVNode("span", null, "Aggiungi valore", -1 /* CACHED */)),
                              _createVNode(_component_base_icon, {
                                icon: _unref(add),
                                class: "crm:ml-3",
                                sizing: {width: '15px', height:'15px'}
                              }, null, 8 /* PROPS */, ["icon"])
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["params", "validate-to"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_89, [
                        _createTextVNode(_toDisplayString(_unref(validazione).ufficio_del_territorio.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ufficio_del_territorio.ref]
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createVNode(_component_base_select, {
                          name: "ufficio_del_territorio",
                          options: [{name: 'Pubblicità immobiliare completa', value: 'pubblicita_immobiliare_completa'},
          {name: 'Solo voltura catastale', value: 'solo_voltura_catastale'}],
                          isSelected: _unref(validazione).ufficio_del_territorio.value !== '',
                          onChange: _cache[30] || (_cache[30] = $event => (select_ufficio_del_territorio($event))),
                          state: __props.readonly === true ?'disable':'',
                          validateTo: _unref(validazione).ufficio_del_territorio,
                          "onUpdate:validateTo": _cache[31] || (_cache[31] = $event => ((_unref(validazione).ufficio_del_territorio) = $event))
                        }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_92, [
                        _createTextVNode(_toDisplayString(_unref(validazione).tipo_societa.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_societa.ref]
                      ]),
                      _createElementVNode("div", _hoisted_93, [
                        _createVNode(_component_base_select, {
                          name: "tipo_societa",
                          options: [{name: 'Società di capitali', value: 'societa_di_capitale'},{name: 'Società di persone', value: 'societa_di_persone'}],
                          state: __props.readonly === true ?'disable':'',
                          isSelected: _unref(validazione).tipo_societa.value !== '',
                          validateTo: _unref(validazione).tipo_societa,
                          "onUpdate:validateTo": _cache[32] || (_cache[32] = $event => ((_unref(validazione).tipo_societa) = $event))
                        }, null, 8 /* PROPS */, ["state", "isSelected", "validateTo"])
                      ])
                    ]),
                    (_unref(validazione).ufficio_del_territorio.value === 'pubblicita_immobiliare_completa')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_95, [
                            _createTextVNode(_toDisplayString(_unref(validazione).quante_conservatorie.label), 1 /* TEXT */)
                          ])), [
                            [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.quante_conservatorie.ref]
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _createVNode(_component_base_input_text, {
                              id: "quante_conservatorie",
                              name: "quante_conservatorie",
                              class: "placeholder-right crm:text-right",
                              placeholder: "Indicare il numero di conservatorie",
                              disabled: __props.readonly,
                              "validate-to": _unref(validazione).quante_conservatorie,
                              "onUpdate:validateTo": _cache[33] || (_cache[33] = $event => ((_unref(validazione).quante_conservatorie) = $event))
                            }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_unref(validazione).ufficio_del_territorio.value === 'solo_voltura_catastale')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_98, [
                            _createTextVNode(_toDisplayString(_unref(validazione).quante_volture.label), 1 /* TEXT */)
                          ])), [
                            [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.quante_volture.ref]
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _createVNode(_component_base_input_text, {
                              id: "quante_volture",
                              name: "quante_volture",
                              class: "placeholder-right crm:text-right",
                              placeholder: "Indicare il numero di volture",
                              disabled: __props.readonly,
                              "validate-to": _unref(validazione).quante_volture,
                              "onUpdate:validateTo": _cache[34] || (_cache[34] = $event => ((_unref(validazione).quante_volture) = $event))
                            }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_unref(regimeFiscale) === 'ordinario')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_101, [
                            _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                          ])), [
                            [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                          ]),
                          _createElementVNode("div", _hoisted_102, [
                            _createVNode(_component_base_input_checkbox, {
                              class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                              name: "ritenuta_acconto",
                              label: "Si, applicabile",
                              "validate-to": _unref(validazione).ritenuta_acconto,
                              "onUpdate:validateTo": _cache[35] || (_cache[35] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                            }, null, 8 /* PROPS */, ["class", "validate-to"])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createVNode(RegimeFiscale, {
                      validazione: _unref(validazione),
                      helper: _unref(indexHelperClosing),
                      readonly: __props.readonly
                    }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                    _createVNode(AliquoteContributiRepertoriali, {
                      validazione: _unref(validazione),
                      helper: _unref(indexHelperClosing),
                      readonly: __props.readonly
                    }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                    _createVNode(CalcoloEquoCompenso, {
                      "input-riferimento-calcolo": "valore_patrimonio_netto_societa_incorporate",
                      validazione: validazioneEquoCompenso.value,
                      "dynamic-input": true,
                      helper: _unref(indexHelperClosing),
                      readonly: __props.readonly
                    }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
                  ]))
                : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}